module.exports = __webpack_public_path__ + "img/guanjun.f80c1c40.png";